<div *ngIf="!userDataLoading && (policyDetails !== undefined) && (claimsData !== undefined); else loading">
  <div class="policy-summary-container padding-medium padding-top-none">
    <div class="grid align-center">
      <div class="cell margin-right-medium margin-left-medium progress-nav margin-bottom-none" [ngClass]="{ 'has-alert': policyDetails.overdueInvoices?.count > 0 }">
        <button mat-icon-button color="primary" (click)="goBack()">
          <mat-icon>west</mat-icon>
        </button>
      </div>
      <div class="cell cell-large-col-span-12" *ngIf="policyDetails.overdueInvoices?.count > 0">
        <open-tile-block
          [title]="policyDetails.overdueInvoices.count > 1 ? 'You have outstanding payments' : 'You have an outstanding payment'"
          [text]="'Retry or change your payment details'"
          (action)="retryPayment()"
          [tileClass]="'error-notification'"
        ></open-tile-block>
      </div>

      <div class="cell cell-large-col-span-12">
        <div class="flex flex-justify-start policy-summary">
          <div class="flex flex-column flex-grow">
            <div class="policy-title">
              <open-svg-icon name="options-hirecar-small" class="small" *ngIf="policyDetails.productClass === 'car'"></open-svg-icon>
              <open-svg-icon name="house-home-small" class="small" *ngIf="policyDetails.productClass === 'home'"></open-svg-icon>
              <open-svg-icon name="travel-small" class="small" *ngIf="policyDetails.productClass === 'travel'"></open-svg-icon>
              <open-svg-icon name="marketing-optionals" class="small" *ngIf="policyDetails.productClass === 'mobile'"></open-svg-icon>
              <h1>{{ policyDisplayTitle }}</h1>
            </div>

            <div class="policy-info">
              <ul class="policy-details">
                <li *ngIf="policyDetails.productClass !== 'mobile'" class="text-small"><strong>{{ policyDetails.policyTypeLabel }}</strong></li>
                <li class="text-small">Policy Number: <strong>{{ policyDetails.policyNumber }}</strong></li>
              </ul>
              <ul class="policy-badges">
                <li *ngIf="policyDetails.paymentPlanData?.isNMonthsFree">
                  <open-badge [label]="policyDetails.paymentPlanData?.promotionMessage" variant="promotion"></open-badge>
                </li>
                <li>
                  <open-badge [label]="policyDetails.policyState" [variant]="badgeStatus[policyDetails.policyState] || 'default'"></open-badge>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="policy-actions">
          <ul>
            <li *ngIf="policyDetails.policyState !== 'cancelled'">
              <button mat-flat-button color="primary" (click)="goToSupport('policy')">
                <div class="flex flex-items-center policy-actions-buttons-wrapper">
                  <open-svg-icon name="management-update-policy-small" class="xsmall"></open-svg-icon>
                  <span>Manage</span>
                </div>
              </button>
            </li>
            <li>
              <button mat-flat-button color="primary" (click)="goToClaims()">
                <div class="flex flex-items-center policy-actions-buttons-wrapper">
                  <open-svg-icon name="management-claim-small" class="xsmall"></open-svg-icon>
                  <span>Claim</span>
                </div>
              </button>
            </li>
            <li *ngIf="displayPaymentsButton()">
              <button mat-flat-button color="primary" (click)="goToSupport('payment')">
                <div class="flex flex-items-center policy-actions-buttons-wrapper">
                  <open-svg-icon name="management-payments-small" class="xsmall"></open-svg-icon>
                  <span>Payments</span>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="policy-tabs">
    <div class="grid align-center padding-medium">
      <div class="cell cell-large-col-span-12">
        <mat-tab-group [selectedIndex]="initialTabState" (selectedTabChange)="tabClicked($event)" mat-stretch-tabs="false" mat-align-tabs="start" fitInkBarToContent>
          <mat-tab label="Policy details">
            <div class="padding-vertical-medium">
              <app-car-policy *ngIf="policyDetails.productClass === 'car'" [policyDetails]="policyDetails" (updatePolicyPage)="getLatestPolicyDetails()"></app-car-policy>
              <app-home-policy *ngIf="policyDetails.productClass === 'home'" [policyDetails]="policyDetails" (updatePolicyPage)="getLatestPolicyDetails()"></app-home-policy>
              <app-travel-policy *ngIf="policyDetails.productClass === 'travel'" [policyDetails]="policyDetails" (updatePolicyPage)="getLatestPolicyDetails()"></app-travel-policy>
              <app-mobile-policy *ngIf="policyDetails.productClass === 'mobile'" [policyDetails]="policyDetails" (updatePolicyPage)="getLatestPolicyDetails()"></app-mobile-policy>
            </div>
          </mat-tab>
          <mat-tab label="Documents">
            <div class="grid padding-vertical-medium policy-docs">
              <div class="cell cell-large-col-span-10 cell-large-col-start-2">
                <p class="policy-docs-title">Click below to download your policy documents</p>
                <ul class="grid policy-docs-list">
                  <li class="cell cell-medium-col-span-8 cell-large-col-span-4" *ngFor="let document of policyDetails.documents">
                    <a class="mat-button policy-docs-download" tabindex="0" (click)="downloadDocument(document.type)" [ngSwitch]="document.type" *ngIf="document">
                      <div class="policy-docs-download-label">
                        <open-svg-icon name="management-claim" class="xmedium" *ngSwitchCase="'coi'"></open-svg-icon>
                        <open-svg-icon name="management-bankaccount" class="xmedium" *ngSwitchCase="'coc'"></open-svg-icon>
                        <open-svg-icon name="management-aboutyourcover" class="xmedium" *ngSwitchCase="'pds'"></open-svg-icon>
                        <span>
                          {{ document.name }}
                        </span>
                      </div>
                      <mat-icon class="file_download material-icons-outlined"></mat-icon>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Claims">
            <div class="padding-vertical-medium">
              <app-claims-list [claims]="claimsData" [label]="policyDisplayTitle"></app-claims-list>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!userDataLoading && isLoadingError">
  <div class="padding-medium padding-top-none">
    <div class="grid align-center">
      <div class="cell margin-right-medium margin-left-xmedium progress-nav">
        <button mat-icon-button color="primary" (click)="goBack()">
          <mat-icon>west</mat-icon>
        </button>
      </div>
      <div class="cell cell-large-col-span-12 padding-bottom-small open-form-info padding-small is-error">
        <p>Something went wrong</p>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="padding-xxbig flex flex-justify-center">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-template>
